/**
 * 画圆圈的笔刷
 * @param {*} fabric
 * @param {*} canvas
 * @returns
 */
export default function(fabric, canvas, options = {}) {
  return new fabric.DiagramBrush(canvas, {
    getObject(opt, pointer) {
      const { originX, originY } = opt
      // const radius = pointer.x - originX
      return new fabric.Ellipse({
        name: options.name,
        left: originX,
        top: originY,
        originX: 'left',
        originY: 'top',
        // 水平方向的半径
        rx: 0,
        // 垂直方向的半径
        ry: 0,
        angle: 0,
        fill: '',
        stroke: 'red',
        strokeWidth: 12,
        ...options.ellipse
      })
    },
    renderMove(opt, pointer) {
      const { originX, originY } = opt
      const { x, y } = pointer
      const ellipse = opt.curObject
      // let radius = Math.max(
      //   Math.abs(originY - pointer.y),
      //   Math.abs(originX - pointer.x)
      // ) / 2
      // if (radius > ellipse.strokeWidth) {
      //   radius -= ellipse.strokeWidth / 2
      // }
      // ellipse.set({ radius })
      const rx = Math.abs(x - originX) / 2
      const ry = Math.abs(y - originY) / 2
      ellipse.set({
        rx,
        ry
      })
      // 右上
      // console.log(pointer, opt)
      if (x > originX && y < originY) {
        ellipse.set({
          originX: 'left',
          originY: 'bottom'
        })
        return
      }
      // 左上
      if (x < originX && y < originY) {
        ellipse.set({
          originX: 'right',
          originY: 'bottom'
        })
        return
      }
      // 左下
      if (x < originX && y > originY) {
        ellipse.set({
          originX: 'right',
          originY: 'top'
        })
        return
      }
      // 四个方向单独处理
      // 右
      // if (originX < pointerX && originY === pointerY) {
      //   angle = 0
      // }
      // // 左
      // if (originX > pointerX && originY === pointerY) {
      //   angle = 180
      // }
      // // 下
      // if (originX === pointerX && originY < pointerY) {
      //   angle = 90
      // }
      // // 上
      // if (originX === pointerX && originY < pointerY) {
      //   angle = 270
      // }
      ellipse.set({
        originX: 'left',
        originY: 'top'
      })
      // if (originY > pointer.x) {
      //   ellipse.set({ originX: 'right' })
      // } else {
      //   ellipse.set({ originX: 'left' })
      // }
      // if (originY > pointer.y) {
      //   ellipse.set({ originY: 'bottom' })
      // } else {
      //   ellipse.set({ originY: 'top' })
      // }
    }
  })
}